module.exports = __webpack_public_path__ + "img/123456.9ce7a3a7.png";